const getStyleVariable = (el, propertyName) => {
  return getComputedStyle(el).getPropertyValue(propertyName)
};

export {getStyleVariable}